


























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreTransaction = namespace("Transaction");

@Component
export default class SectionSummary extends Vue {
  @Prop({}) readonly transactionCreate!: any;

  @StoreTransaction.Mutation
  private MutationOnHumanEventChangeTransactionItem!: (transactionCreate: any) => void;

  @Watch("transactionCreate.transactionDiscount.isActive")
  isActiveDiscountChanged(newVal: boolean) {
    if (!newVal) {
      this.transactionCreate.transactionDiscount.value = "0.00";
      this.transactionCreate.transactionDiscount.validateError = false;
      this.OnChangeTransactionDiscount();
    }
  }
  @Watch("transactionCreate.transactionDiscount.disabled")
  isDisabledDiscountChanged(newVal: boolean) {
    if (newVal) {
      this.transactionCreate.transactionDiscount.isActive = false;
    }
  }

  public OnChangeTransactionDiscount() {
    this.transactionCreate.transactionDiscount.value = this.transactionCreate.transactionDiscount.value.FormatMoney();
    this.OnChangeTransactionItem();
  }
  OnChangeTransactionItem() {
    this.MutationOnHumanEventChangeTransactionItem(this.transactionCreate);
  }
}
